import React from 'react';
import { useTranslation } from 'react-i18next';
import Slider from 'apollo-react/components/Slider';
import Typography from '../../../../StyledTypography';
import FieldWrapper from '../../fields/FieldWrapper';
import styles from '../IDSField.module.css';

const SliderFieldInput = ({
  id,
  label,
  value,
  onChange,
  disabled,
  required,
  columnStyle,
  helperText,
  min,
  max,
  step,
}) => {
  const { t } = useTranslation();

  const handleChange = (event, newValue) => {
    onChange(newValue);
  };

  return (
    <FieldWrapper style={columnStyle}>
      <Typography variant="bodySmall" className={styles.fieldLabel}>
        {label}
        {required && <span className={styles.requiredIndicatorRed}> *</span>}
      </Typography>
      <Slider
        id={id}
        name={id}
        value={typeof value === 'number' ? value : min || 0}
        onChange={handleChange}
        min={min || 0}
        max={max || 100}
        step={step || 1}
        disabled={disabled}
        valueLabelDisplay="auto"
      />
      <Typography variant="caption" color="textSecondary">
        {helperText ||
          t('formRenderer.sliderMinMax', {
            min: min || 0,
            max: max || 100,
          })}
      </Typography>
    </FieldWrapper>
  );
};

export default SliderFieldInput;
